import type { DepartureCity } from '@/shared/model';

// id городов, закреплённых в начале списка; остальные — по алфавиту
const CITIES_ORDER: readonly number[] = [2, 1];

export function sortCities(cities: DepartureCity[]): DepartureCity[] {
  const pinned: DepartureCity[] = [];
  for (const id of CITIES_ORDER) {
    const city = cities.find((c) => c.id === id);
    if (city) {
      pinned.push(city);
    }
  }

  const rest = cities.filter((c) => !CITIES_ORDER.includes(c.id)).sort((a, b) => a.name.localeCompare(b.name, 'ru'));

  return [...pinned, ...rest];
}
